import api from "@/lib/api";
import { toast } from "sonner";
import confetti from "canvas-confetti";

const KEY = "pula_ref";
const SRC_KEY = "pula_ref_src";

// Capture ?ref= (and optional ?src= for attribution) from the URL and remember
// it across the signup journey (email verification, Google redirect roundtrip).
export function captureReferral() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  const src = params.get("src");
  if (ref) sessionStorage.setItem(KEY, ref.trim());
  if (src) sessionStorage.setItem(SRC_KEY, src.trim());
  return sessionStorage.getItem(KEY);
}

// Redeem the remembered code after a successful signup. The backend safely
// rejects non-new / self / already-referred accounts, so this is idempotent.
export async function applyStoredReferral() {
  const code = sessionStorage.getItem(KEY);
  if (!code) return;
  const src = sessionStorage.getItem(SRC_KEY) || "";
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem(SRC_KEY);
  try {
    await api.post("/referrals/redeem", { code, src });
    toast.success("You joined with a friend's invite — welcome to Pula! 🌧️");
  } catch { /* not eligible — ignore quietly */ }
}

// Fire a one-time confetti + toast celebration when a member crosses into a new
// referral tier. `data` is the /referrals/me response; `userId` scopes the memory
// so each member only celebrates each milestone once.
// Returns the newly-reached badge (so the caller can offer a share card), else null.
export function celebrateMilestone(data, userId) {
  if (!data?.badge || !userId) return null;
  const storeKey = `pula_ref_celebrated_${userId}`;
  const last = Number(localStorage.getItem(storeKey) || 0);
  const reached = Math.max(...(data.tiers || []).filter((t) => t.reached).map((t) => t.threshold), 0);
  if (reached <= last) { if (reached > 0) localStorage.setItem(storeKey, String(reached)); return null; }
  localStorage.setItem(storeKey, String(reached));

  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  if (!reduce) {
    const end = Date.now() + 900;
    const colors = ["#2E7DB6", "#4E9F3D", "#F4C430"];
    (function frame() {
      confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors });
      confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  }
  toast.success(`${data.badge.emoji} Milestone reached — you're now a ${data.badge.name}! Thank you for growing Pula. 💧`, { duration: 6000 });
  return data.badge;
}
